// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let AuthSession = require("./AuthSession.bs.js");

function SessionRenewer(props) {
  let authSession = AuthSession.use();
  let expiresAt = authSession !== undefined && authSession.__typename === "AuthSession" ? authSession.expiresAt : undefined;
  React.useEffect(() => {
    if (expiresAt === undefined) {
      return;
    }
    let expiresIn = expiresAt - Date.now();
    let refreshSessionAt = Math.max(0, expiresIn - 5 * 60 * 1000);
    let intervalId = setInterval(() => {
      AuthSession.createSession();
    }, refreshSessionAt);
    return () => {
      clearInterval(intervalId);
    };
  }, [expiresAt]);
  return null;
}

let make = SessionRenewer;

exports.make = make;
/* react Not a pure module */
